import React, { useEffect, useState } from "react";
import {
  Modal,
  TextInput,
  Button,
  Group,
  Stack,
  Alert,
  Select,
} from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";

const AddOrgLevelEntityModal = ({
  opened,
  onClose,
  onSave,
  orgLevelTypes = [],
}) => {
  const [name, setName] = useState("");
  const [typeId, setTypeId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (opened) {
      setName("");
      setError("");
      setTypeId(
        orgLevelTypes.length === 1 ? String(orgLevelTypes[0].id) : null
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [opened]);

  const handleSave = async () => {
    if (!name.trim()) {
      setError("Name is required");
      return;
    }
    if (!typeId) {
      setError("Group type is required");
      return;
    }

    setLoading(true);
    setError("");

    try {
      await onSave({
        name: name.trim(),
        orgLevelTypeId: Number(typeId),
      });
      onClose();
    } catch (err) {
      setError(err.message || "Failed to create entity");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setName("");
    setTypeId(null);
    setError("");
    onClose();
  };

  const selectedType = orgLevelTypes.find(c => String(c.id) === typeId);
  const title = selectedType ? `New ${selectedType.name}` : "New Group";
  const canSubmit = !!name.trim() && !!typeId;

  return (
    <Modal opened={opened} onClose={handleClose} title={title} size="md">
      <Stack gap="md">
        {error && (
          <Alert
            icon={<IconAlertCircle size={16} />}
            color="red"
            variant="light"
          >
            {error}
          </Alert>
        )}

        <TextInput
          label="Name"
          placeholder="Enter name"
          value={name}
          onChange={e => setName(e.target.value)}
          required
        />

        <Select
          label="Group Type"
          placeholder="Select group type"
          data={orgLevelTypes.map(c => ({
            value: String(c.id),
            label: c.name,
          }))}
          value={typeId}
          onChange={setTypeId}
          required
        />

        <Group justify="flex-end" gap="sm">
          <Button variant="outline" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button onClick={handleSave} loading={loading} disabled={!canSubmit}>
            Add
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default AddOrgLevelEntityModal;
